<template>
  <div class="main-wrapper fitness-center">
    <div class="container">
      <div class="invoice-wrapper download_section">
        <div class="inv-content">
          <div class="invoice-header">
            <div class="inv-header-left">
              <div class="invoice-title tax-invoice">TAX INVOICE</div>
              <div class="company-details">
                <span class="company-name invoice-title">Dreamguys Fitness Center</span>
                <div class="gst-details">GST IN: <span>22AABCU9603R1ZX</span></div>
                <div class="gst-details">
                  Address:
                  <span>5 Hodges Mews, High Wycombe HP12 3JL, United Kingdom</span>
                </div>
                <div class="gst-details mb-0">Mobile: <span>+ 91 98765 43210</span></div>
              </div>
            </div>
            <div class="inv-header-right">
              <a href="javascript:;">
                <img src="@/assets/img/logo2.png" alt="Logo" />
              </a>
              <div class="inv-details">
                <div class="inv-date">Date: <span>5/12/2022</span></div>
                <div class="inv-date mb-0">Invoice No: <span>INV 00001</span></div>
              </div>
            </div>
          </div>
          <div class="invoice-address">
            <div class="invoice-to">
              <span>Customer Details:</span>
              <span class="invoice-title">John Williams</span>
            </div>
            <div class="grand-total">
              <span>Grand Total</span>
              <span>$270</span>
            </div>
          </div>
          <div class="invoice-table">
            <div class="table-responsive">
              <table>
                <thead>
                  <tr class="fitness-center">
                    <th class="table_width_1">#</th>
                    <th class="table_width_2">Description</th>
                    <th class="text-center">Hours</th>
                    <th class="text-center">Price</th>
                    <th class="text-end">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td class="table-description">Swimming Instructor Fee</td>
                    <td class="text-center">10</td>
                    <td class="text-center">$50</td>
                    <td class="text-end">$50</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td class="table-description">Morning Yoga</td>
                    <td class="text-center">6</td>
                    <td class="text-center">$50</td>
                    <td class="text-end">$50</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td class="table-description">Massage Therapy</td>
                    <td class="text-center">10</td>
                    <td class="text-center">$100</td>
                    <td class="text-end">$100</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td class="table-description">Abs Workout</td>
                    <td class="text-center">10</td>
                    <td class="text-center">$100</td>
                    <td class="text-end">$100</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="invoice-table-footer">
            <div class="table-footer-left notes"></div>
            <div class="text-end table-footer-right">
              <table>
                <tbody>
                  <tr>
                    <td>Taxable Amount</td>
                    <td>$300.00</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="invoice-table-footer">
            <div class="table-footer-left notes">
              <span></span>
            </div>
            <div class="text-end table-footer-right">
              <table>
                <tbody>
                  <tr>
                    <td>IGST 18.0%</td>
                    <td>$30.00</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="invoice-table-footer">
            <div class="table-footer-left">
              <span class="total-item">Total Items / Qty : 4 / 4.00</span>
            </div>
            <div class="text-end table-footer-right">
              <table>
                <tbody>
                  <tr>
                    <td class="invoice-title">Total</td>
                    <td class="invoice-title">$270.00</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="invoice-table-footer payable-table">
            <div class="table-footer-left notes">
              Total amount ( in words): <span>USD Two Hundred Seventy Dollars Only.</span>
            </div>
            <div class="text-end table-footer-right amount-payable">
              <table>
                <tbody>
                  <tr>
                    <td class="invoice-title">Amount Payable</td>
                    <td class="invoice-title">$270.00</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="bank-details">
            <div class="payment-info">
              <span class="payment-title">Payment Info:</span>
              <div><span>Debit Card :</span> 465 *************645</div>
              <div><span>Amount :</span> $1,815</div>
            </div>
            <div class="company-sign">
              <span>For Dreamguys</span>
              <img src="@/assets/img/signature.png" alt="" />
            </div>
          </div>
          <div class="terms-condition">
            <span>Terms and Conditions:</span>
            <ol>
              <li>Goods Once sold cannot be taken back or exchanged</li>
              <li>
                We are not the manufactures, company will stand for warrenty as per their
                terms and conditions.
              </li>
            </ol>
          </div>
          <div class="thanks-msg text-center">Thanks for your Business</div>
        </div>
      </div>
      <div class="file-link">
        <button class="download_btn download-link">
          <i class="feather-download-cloud me-1"></i> <span>Download</span>
        </button>
        <a href="javascript:window.print()" class="print-link">
          <i class="feather-printer"></i> <span class="">Print</span>
        </a>
      </div>
    </div>
  </div>
</template>
